if(!customElements.get('risify-description')){
  class RisifyDescription extends HTMLElement {
    constructor() {
      super();
      this.productGrid = this.parentElement.nextElementSibling;
      this.description = this.querySelector('.risify-description-wrapper');
      this.gridButton = this.querySelector('.description-button[data-section="grid"]');
      this.descriptionButton = this.querySelector('.description-button[data-section="description"]');

      this.gridButton.addEventListener('click', () => {
        this.descriptionButton.classList.remove('active');
        this.gridButton.classList.add('active');
        this.productGrid.classList.remove('hidden');
        this.description.classList.remove('active');
      });
      this.descriptionButton.addEventListener('click', () => {
        this.descriptionButton.classList.add('active');
        this.gridButton.classList.remove('active');
        this.productGrid.classList.add('hidden');
        this.description.classList.add('active');
      });
    }
  }
  customElements.define('risify-description', RisifyDescription);
}

if(!customElements.get('risify-accordion')){
  class RisifyAccordion extends HTMLElement {
    constructor() {
      super();
      this.answer = this.querySelector('.risify-faq-answer');
      this.question = this.querySelector('.risify-faq-question');

      this.question.addEventListener('click', () => {
        if(this.classList.contains('is-open')){
          this.classList.remove('is-open');
          this.answer.style.maxHeight = null;
        } else {
          this.classList.add('is-open');
          this.answer.style.maxHeight = this.answer.scrollHeight + 48 + 'px';
        }
      });
    }
  }
  customElements.define('risify-accordion', RisifyAccordion);
}